export default __webpack_public_path__ + "geburtstag-teaser-02.1ee3b379d06aa310e23d4f20004c00d2.png";